import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";

import DashboardListBuilding from "components/dashboard/DashboardListBuilding";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";

export default () => {
  // Fetch data
  const GET_LIST_BUILDING_DATA = gql`
    query GetListBuildingData {
      listBuildingData {
        leadsStats {
          last24HoursLeads
          last24HoursVerifiedLeads
          prev24HoursLeads
          prev24HoursVerifiedLeads
          last7DaysLeads
          last7DaysVerifiedLeads
          prev7DaysLeads
          prev7DaysVerifiedLeads
          allLeads
          allVerifiedLeads
          trendsData
        }
        lists {
          id
          name
          last24hoursLeads
          last7DaysLeads
          allLeads
        }
      }
    }
  `;

  const { data, error } = useQuery(GET_LIST_BUILDING_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching pages overview data", error);
    captureException(error);
  }

  //console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="435px" />
        </LoadingBox>
      )}
      {data && <DashboardListBuilding data={data} />}
    </>
  );
};
